import { render } from "./Search.vue?vue&type=template&id=5bd7dc6b&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import "./Search.vue?vue&type=style&index=0&id=5bd7dc6b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5bd7dc6b"

export default script